import { AxiosResponse } from 'axios';
import { API_ROUTES } from 'data/ApiRoutes';
import { GET, POST } from 'data/services/api';

export interface GmailConnectionStatus {
  mailbox: string;
  configured: boolean;
  pollingEnabled: boolean;
  connected: boolean;
  connectedDate?: string | null;
  connectedByName?: string | null;
  lastPollDate?: string | null;
}

// Only the backend's own messages reach the admin, as written ("Sign in to
// Google as support@..."). The interceptor passes those as strings; anything
// else is a transport error ("Network Error", "status code 502") and the page
// shows its own wording instead.
const rethrow = (e: unknown): never => {
  throw Error(typeof e === 'string' ? e : '');
};

export const getGmailConnectionStatus =
  async (): Promise<GmailConnectionStatus> => {
    try {
      const res: AxiosResponse<GmailConnectionStatus> = await GET(
        API_ROUTES.gmailConnection,
      );
      return res.data;
    } catch (e: unknown) {
      return rethrow(e);
    }
  };

export const startGmailConnection = async (): Promise<{ url: string }> => {
  try {
    const res: AxiosResponse<{ url: string }> = await POST(
      API_ROUTES.gmailConnectionStart,
      {},
    );
    return res.data;
  } catch (e: unknown) {
    return rethrow(e);
  }
};

export const finishGmailConnection = async (
  code: string,
  state: string,
): Promise<GmailConnectionStatus> => {
  try {
    const res: AxiosResponse<GmailConnectionStatus> = await POST(
      API_ROUTES.gmailConnectionFinish,
      { code, state },
    );
    return res.data;
  } catch (e: unknown) {
    return rethrow(e);
  }
};
